import {ButtonSeverity} from 'primeng/button';
import {EStatusTagDisplayMode} from '../status-tag/status-tag.component';
import {MenuItem} from 'primeng/api';
import {Type} from '@angular/core';
import {IDataCellDisplayComponent} from '../../data-cell-display/idata-cell-display/idata-cell-display.component';

export enum ETableColType {
    ORDER = 'ORDER',
    DATA = 'DATA',
    BUTTON = 'BUTTON',
    POPUP_MENU = 'POPUP_MENU'
}

export enum ETableColDataType {
    LONG_TEXT = 'LONG_TEXT',
    IMAGE = 'IMAGE',
    DATE = 'DATE',
    BOOLEAN_LABEL = 'BOOLEAN_LABEL',
    BOOLEAN_ICON = 'BOOLEAN_ICON',
    BOOLEAN_ICON_INV = 'BOOLEAN_ICON_INV',
    CHECKBOX = 'CHECKBOX',
    CONDITIONAL_CHECKBOX = 'CONDITIONAL_CHECKBOX',
    TAGS = 'TAGS',
    CHIPS = 'CHIPS',
    EDITABLE_TEXT = 'EDITABLE_TEXT',
    TEXT = 'TEXT',
    LINK = 'LINK',
    STATUS_TAG = 'STATUS_TAG',
    DATA_DISPLAY_CELL_COMPONENT = 'DATA_DISPLAY_CELL_COMPONENT'
}

export enum ETableColFilterType {
    TEXT = 'TEXT',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN',
    SELECT = 'SELECT',
    MULTISELECT = 'MULTISELECT'
}

export enum ETableColCondition {
    ALL = 'All',
    ROOT_ONLY = 'Root Only',
    NON_ROOT_ONLY = 'Non root only'
}

export enum ETableColFreeze {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}

export class TableTagDef {
    constructor(
        public value: string | number | boolean,
        public label: string,
        public icon?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public style?: Record<string, any>,
        public tooltip?: string,
        public styleClass?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public iconStyle?: Record<string, any>
    ) {}
}

export class TableColDef {
    public __iID?: number;

    constructor(
        public header: string,
        public field: string,
        public type?: ETableColType,
        public dataType?: ETableColDataType,
        public dataCellDisplayComponent?: Type<IDataCellDisplayComponent<unknown, unknown>>,
        public dataCellDisplayExtra?: unknown,
        public condition?: ETableColCondition,
        public searcheable?: boolean,
        public filterable?: boolean,
        public sortable?: boolean,
        public filterType?: ETableColFilterType,
        public filterSelectOptions?: TableTagDef[],
        public filterSelectDefaultOption?: string,
        public freeze?: ETableColFreeze,
        public tags?: TableTagDef[],
        public statusTagDisplayMode?: EStatusTagDisplayMode,
        public statusTagLockEvalColumn?: string,
        public tooltip?: string,
        public tooltipField?: string,
        public icon?: string,
        public customDateFormat?: string,
        public model?: MenuItem[],
        public popup?: boolean,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public tdStyle?: Record<string, any>,
        public colWidth?: string,

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCustomPrefixIcon?: (row: any) => string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCustomData?: (row: any) => any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnChildrenRows?: (row: any) => any[],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCellWrappingClassName?: (row: any) => string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnOnCellClick?: (row: any) => void,

        public buttonSeverity?: ButtonSeverity,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnOnButtonClick?: (row: any) => void
    ) {}
}
